module.exports = __webpack_public_path__ + "e048455183debbae6d8e7f5e4201def7.png";